import { useState, useCallback } from 'react'
import { FormikHelpers } from 'formik'
import { createContainer } from 'unstated-next'
import * as api from 'lib/api/pointOfSale'
import { extractNameValues } from 'lib/utils'
import useTrackingTag from 'lib/hooks/useTrackingTag'

export interface LeadFormValues {
  fullName: string
  email: string
  optIn: boolean
}

type SubmitLead = (
  values: LeadFormValues,
  actions: FormikHelpers<LeadFormValues>
) => Promise<string>

type InitNextPage = (url: string) => void

export interface LeadContainer {
  initNextPage: InitNextPage
  lead?: api.SubmitLeadRequest
  submitLead: SubmitLead
}

const useLead = () => {
  // This is always set at build time
  const [nextPage, setNextPage] = useState<string>(undefined!)
  const [lead, setLead] = useState<api.SubmitLeadRequest>()
  const trackingTag = useTrackingTag()

  const submitLead = useCallback<SubmitLead>(
    async (values, { setSubmitting }) => {
      const getLead = (values: LeadFormValues) => {
        return {
          ...values,
          ...extractNameValues(values.fullName),
          ...trackingTag,
        }
      }

      const saveLead = (values: api.SubmitLeadRequest) => {
        setLead(values)

        // Perform lead save asynchronously
        setTimeout(() => {
          try {
            api.submitLead(values)
          } catch (err) {
            if (err instanceof Error) {
              console.log('Error submitting lead: ' + err.message)
            } else {
              console.log('Error submitting lead: ' + err)
            }
          }
        })
      }

      if (values.optIn) {
        saveLead(getLead(values))
      }

      setSubmitting(false)
      return nextPage
    },
    [nextPage, trackingTag]
  )

  const initNextPage = useCallback<InitNextPage>(
    (nextPage) => setNextPage(nextPage),
    []
  )

  return { lead, submitLead, initNextPage }
}

export default createContainer<LeadContainer>(useLead)
